module.exports = __webpack_public_path__ + "static/media/404.98d9f080.png";